module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';



// WEBPACK FOOTER //
// /Users/stephen.tait/Local Sites/storyiq/app/public/web/wp-content/themes/jaywing/node_modules/core-js/internals/engine-user-agent.js